<template >
  <div class="top">
    <div class="welcome">
      <div class="image">
        <img src="../assets/img/Logo.png" width="50 px" height="50 px" />
      </div>

      <h2 style="text-align: center">Hi, {{ StudentProfile.StudentName}}</h2>

      <p style="text-align: center">Welcome to pickiddo Quiz!</p>

      <br />

      <div>
        <div>
          <div>
            <div class="P1">
              <p style="font-size: 13px">
                Your daily quiz is wating for you, but first please select your
                grade level.
              </p>
            </div>
          </div>

          <hr />

          <div align="right">
            <span v-for="item in grades" v-bind:key="item.Id">
              <CCard
                style="background: #ebedef"
                class="p-2 box-shadow mb-1"
                @click="GotoPageSubject(item.Id)"
              >
                <CCol sm="12" lg="12">
                  <CRow>
                    <div class="col-2" style="padding: 0px; text-align: left">
                      <h1
                        style="
                          font-size: revert;
                          text-transform: uppercase;
                          color: #fff;
                        "
                        class="square-bg p-1 box-shadow"
                      >
                        <span>{{ item.GradeName.substring(0, 1) }}</span>
                      </h1>
                    </div>

                    <div class="col-10 text-left text-black">
                      <span style="color: rgb(33 162 162)" class="small"
                        >Grade
                      </span>
                      <h6 class="custom-font">{{ item.GradeName }}</h6>
                    </div>
                  </CRow>
                </CCol>
              </CCard>
            </span>
            <!-- <button class="button1">Year 1</button>
            <button class="button2">Year 2</button>
            <button class="button3">Year 3</button>
            <button class="button4">Year 4</button>
            <button class="button5">Year 5</button>
            <button class="button6">Year 6</button>
            <button class="button7">Form 1</button>
            <button class="button8">Form 2</button>
            <button class="button9">Form 3</button>
            <button class="button10">Form 4</button>
            <button class="button11">Form 5</button> -->
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "QuizStudentDashboard",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      // subjects: [],
      grades: [],
      StudentProfile: {}
      // SelectedSubject: "",
      // SelectedGrade: "",
      // Question: "",
      // SelectedTimer: "",
      // SubmittedForm: false,
      // Error: false
    };
  },
  async mounted() {
    this.GetStudentProfile();
    this.GetGradeList();
  },
  computed: {},
  methods: {
    async GetStudentProfile() {
      this.$API
        .get(
          this.$StudentProfile +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentProfile = response.data;
            console.log("StudentProfile", this.StudentProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GetGradeList() {
      this.$API
        .get(this.$QuizGradeList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
            console.log(this.grades);
          }
        });
    },
    GotoPageSubject(gradeId) {
      this.$router.push(
        "/QuizSubject?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId +
          "&gradeId=" +
          gradeId
      );
    },
  },
};
</script>

<style>
body {
  background-color: darkgray;
  border-right: 20px solid darkgray;
  width: 100%;
  margin: 10px;
  height: 150%;
}

.top {
  background-color: darkgray;
  width: 300;
  padding: 0px;
  height: 100%;
}

.welcome {
  background-color: white;
  padding-top: 50px;
  padding-right: 40px;
  padding-left: 25px;
}
.image {
  text-align: center;
}

.image2 {
  border: 0px solid darkgreen;
  width: 100px;
  height: 40px;
  margin-left: 30px;
}

.float-child {
  width: 100%;
  padding: 15px;
  height: 500px;
  border: 2px solid red;
  border-style: outset;
  background-color: white;
}
.float-container {
  border: 2px solid orange;
  width: 100%;
}

.menu {
  border: 3px solid lightgreen;
}

.button {
  background-color: #008b8b;
  color: white;
  padding: 5px 5px 5px 70px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
}
.button1 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 5px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button2 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 15px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button3 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 25px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button4 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 35px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button5 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 45px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button6 {
  background-color: rgb(109, 41, 138);
  color: white;
  padding: 1px 5px 1px 55px;
  text-align: right;
  text-decoration: none;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 15px;
}

.button7 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 65px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button8 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 75px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button9 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 85px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button10 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 95px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

.button11 {
  background-color: #008b8b;
  color: white;
  padding: 1px 5px 1px 105px;
  text-align: right;
  display: block;
  font-size: 15px;
  margin: 2px 1px;
  cursor: pointer;
  border-radius: 12px;
}

#main {
  width: 100%;
  height: 80px;
  border: 1px solid #941515;
  display: flex;
  justify-content: center;
}

#main div {
  width: 210px;
  height: 0px;
}
</style> 